import { Container } from "react-bootstrap";
import Slider from "react-slick";
import ApiService from "../../../../services/api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../../../services/auth";
import "../css/heros.css";  


const Heros = () => {

  const { isEnglish } = useContext(AuthContext);

  const [slider, setSlider] = useState({});
  const [Loading, setLoading] = useState(true);

  const fetchHeros = async () => {
    const herosList = await ApiService.getSlidersHero();
    setSlider(herosList);
    setLoading(false);
  };

  useEffect(() => {
    fetchHeros();
  }, []);

  if (Loading) {
    return;
  }

  const settings = {
    arrows: false,
    dots: false,
    fade: true,
    infinite: true,
    autoplay: true,
    draggable: false,
    autoplaySpeed: 5000,
    speed: 1500,
    pauseOnHover: false,
    pauseOnFocus: false,
  };

  return (
    <Container fluid className="w-100 h-100 p-0 object-fit-cover m-0">
      <Slider {...settings}>
        {slider.map(({ id, img }) => {
          return (
            <div className=" margin-custom-hero " key={id}>
              <img src={img} alt="" className="custom-image h-100"></img>
              <Container className="w-100 h-100 text-center text-heros d-flex flex-column align-items-center justify-content-center">
                <h1
                  className="text-white h1_home m-0"
                  style={{ fontFamily: "Josefin Sans" }}
                >
                  ROSELLA CLEMENTI
                </h1>
                <h2
                  className="text-white h2_home"
                  style={{ fontFamily: "Josefin Sans" }}
                >
                  {isEnglish ? "Composer Sound Designer" : "Compositrice Sound Designer"}
                </h2>
              </Container>
            </div>
          );
        })}
      </Slider>
    </Container>
  );
};
export default Heros;
